<template>
	<input
		v-model="searchQuery"
		class="input search-bar text-align-left"
		data-test="search-bar"
		maxlength="255"
		:placeholder="placeholder"
		type="text"
		@keyup.enter.stop="submit"
	/>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { useRouter } from 'vue-router';
interface Props {
	placeholder?: string;
}

withDefaults(defineProps<Props>(), {
	placeholder: ''
});

const router = useRouter();
const searchQuery = ref('');

const submit = useDebounceFn(() => {
	try {
		router.push({ name: 'help-center-search', query: { query: searchQuery.value } });
	} catch {}
}, 500);
</script>

<style lang="scss" scoped>
.search-bar {
	box-sizing: border-box;
	padding-right: 2.5em;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16px' height='16px' viewBox='0 0 16 16'%3E%3Ctitle%3Esearch-icon%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Ccircle id='Oval' stroke='%23878C92' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' fill-rule='nonzero' cx='6.5' cy='6.5' r='5.5'%3E%3C/circle%3E%3Cpolygon id='Path-2' fill='%23878C92' fill-rule='nonzero' points='16 14 11.5 9.5 9.5 11.5 14 16'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E");
	background-repeat: no-repeat;
	background-position: calc(100% - 1em) 50%;
}
</style>
